import {inject} from "@angular/core";
import {Router, ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of, EMPTY} from "rxjs";
import {mergeMap, take} from "rxjs/operators";
import {ORGANISER_DASHBOARD, ORGANISER_EVENT_ADD} from "src/app/app-routing.module";
import {EventItem, FetchEventByIdRequest} from "@model";
import {EventService} from "@services";

export const CopyEventResolver: ResolveFn<Observable<EventItem | null> |
  Promise<EventItem> | EventItem> = (route: ActivatedRouteSnapshot,
                                     state: RouterStateSnapshot,
                                     eventService: EventService = inject(EventService),
                                     router: Router = inject(Router)): Observable<EventItem | null> |
  Promise<EventItem> | EventItem => {
  let eventId = route.queryParams["eventId"];
  if (!eventId) {
    router.navigate([ORGANISER_EVENT_ADD]);
    return EMPTY;
  } else {
    return eventService.fetchEventToCopy(
      new FetchEventByIdRequest(eventId), true)
      .pipe(
        take(1),
        mergeMap((res: EventItem | null) => {
          if (res) {
            return of(res);
          } else {
            router.navigate([ORGANISER_DASHBOARD]);
            return EMPTY;
          }
        })
      );
  }
}
